import apiClient from "@/api/client";

export interface Prefix {
  id: number;
  prefix: string;
  vrf: string | null;
  tenant: string;
  status: "active" | "reserved" | "deprecated";
  description: string;
  utilization: number;
}

export interface IPAddress {
  id: number;
  address: string;
  hostname: string | null;
  tenant: string;
  status: "active" | "reserved" | "deprecated" | "dhcp";
  assigned_vm: string | null;
  description: string;
  created_at: string;
}

export interface DNSZone {
  id: number;
  name: string;
  type: "forward" | "reverse";
  records_count: number;
  tenant: string;
  status: "active" | "inactive";
}

export interface DHCPLease {
  id: number;
  ip_address: string;
  mac_address: string;
  hostname: string;
  start_time: string;
  end_time: string;
  status: "active" | "expired";
}

export interface AllocateAddressPayload {
  prefix_id: number;
  hostname?: string;
  description?: string;
  tenant_id: number | string;
}

export async function getPrefixes(tenantId?: number | string): Promise<Prefix[]> {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const { data } = await apiClient.get<Prefix[]>("/ipam/prefixes", {
    params,
  });
  return data;
}

export async function getAddresses(tenantId?: number | string): Promise<IPAddress[]> {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const { data } = await apiClient.get<IPAddress[]>("/ipam/addresses", {
    params,
  });
  return data;
}

export async function allocateAddress(
  payload: AllocateAddressPayload
): Promise<IPAddress> {
  const { data } = await apiClient.post<IPAddress>(
    "/ipam/addresses/allocate",
    null,
    {
      params: {
        prefix_id: payload.prefix_id,
        description: payload.description || "",
        dns_name: payload.hostname || "",
      },
    }
  );
  return data;
}

export async function getDNSZones(tenantId?: number | string): Promise<DNSZone[]> {
  const params = tenantId ? { tenant_id: tenantId } : {};
  const { data } = await apiClient.get<DNSZone[]>("/ipam/dns/zones", {
    params,
  });
  return data;
}

export async function getDHCPLeases(): Promise<DHCPLease[]> {
  const { data } = await apiClient.get<DHCPLease[]>("/ipam/dhcp/leases");
  return data;
}
